import { getObjectUtil } from 'packages/src'
import getDomainPathFromPathReduxUtil from '../get-domain-path-from-path'
import { getIdReduxUtil } from '../get-id'
import { REFERENCES_DOMAIN } from '../../../references/constants'
import addReferenceUtil from '../../../references/utils/add'
import removeReferenceUtil from '../../../references/utils/remove'
import setUtil from '../../../../utils/set'

/**
 * Sets the id and the reference of the given path.
 * @param {Object} params
 *        {string} params.path
 *        {Object} params.state
 *        {string} [params.instance]
 */
function setIdReduxUtil (params) {
  const {
    path,
    id
  } = params
  let {
    state,
    instance
  } = params

  const currentId = getObjectUtil(state, path)
  const domainPath = getDomainPathFromPathReduxUtil(path)
  const currentPath = `${domainPath}.data.${currentId}`
  const newId = instance
    ? getIdReduxUtil(instance)
    : id || null
  const newPath = `${domainPath}.data.${newId}`
  const currentInstance = getObjectUtil(state, currentPath)
  const instanceParams = params.instance
  instance = instanceParams || getObjectUtil(state, newPath)

  // Remove the current reference
  if (currentInstance) {
    const removeReferenceObj = removeReferenceUtil({
      instance: currentInstance,
      referencePath: path,
      state
    })
    if (removeReferenceObj) {
      state = setUtil(state, REFERENCES_DOMAIN, removeReferenceObj.domain)
    }
  }

  state = setUtil(state, path, newId)

  if (instance) {
    const addReferenceObj = addReferenceUtil({
      instance,
      referencePath: path,
      state
    })
    if (addReferenceObj) {
      state = setUtil(
        state,
        addReferenceObj.referencesPath,
        addReferenceObj.newReferences,
        { step: 1 }
      )
    }
  }
  return state
}

export { setIdReduxUtil }
